<template>
  <div class="content home-page faq-page">
    <div class="faq-page-inner">
      <div class="faq-header">
        <button class="faq-back" @click="back">
          <img src="../../static/images/back.png" alt="back">
        </button>
        <div class="faq-title">{{$t('FAQ')}}</div>
        <div class="faq-header-placeholder"></div>
      </div>

      <div class="faq-card" v-if="list !== ''">
        <div class="faq-card-content" v-html="list"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: ''
    }
  },
  created() {
    this.getHome()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getHome() {
      let that = this
      let data = {
        type: '1'
      }
      that.$api.post('/api/index/help', data, r => {
        that.$parent.returnCode(r, function () {
          if (localStorage.getItem('lang') == 'en') {
            that.list = r.data.content
          } else {
            that.list = r.data.mm_content
          }
          that.$parent.loadModal(false)
        })
      })
    }
  }
}
</script>
<style scoped>
.faq-page {
  min-height: 100vh;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center center fixed;
  background-size: cover;
}

.faq-page-inner {
  min-height: 100vh;
  padding: 86px 32px 48px;
  box-sizing: border-box;
}

.faq-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.faq-back {
  width: 72px;
  height: 72px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.faq-back img {
  display: block;
  width: 100%;
}

.faq-header-placeholder {
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}

.faq-title {
  flex: 1;
  text-align: center;
  font-size: 60px;
  line-height: 1;
  font-weight: 700;
  color: #ffffff;
  text-shadow:
    -2px -2px 0 rgba(231, 88, 124, 0.95),
    2px -2px 0 rgba(231, 88, 124, 0.95),
    -2px 2px 0 rgba(231, 88, 124, 0.95),
    2px 2px 0 rgba(231, 88, 124, 0.95);
}

.faq-card {
  margin-top: 42px;
  height: calc(100vh - 248px);
  padding: 34px 28px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.94);
  box-sizing: border-box;
  box-shadow: 0 18px 40px rgba(73, 30, 20, 0.14);
}

.faq-card-content {
  height: 100%;
  overflow-y: auto;
  padding-right: 10px;
  font-size: 22px;
  line-height: 1.7;
  color: #222222;
  word-break: break-word;
}

.faq-card-content::-webkit-scrollbar {
  width: 8px;
}

.faq-card-content::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #f6a121;
}

.faq-card-content::-webkit-scrollbar-track {
  background: transparent;
}

.faq-card-content :deep(h1),
.faq-card-content :deep(h2),
.faq-card-content :deep(h3),
.faq-card-content :deep(h4),
.faq-card-content :deep(strong) {
  color: #111111;
  font-weight: 700;
}

.faq-card-content :deep(p) {
  margin: 0 0 20px;
}

.faq-card-content :deep(ul),
.faq-card-content :deep(ol) {
  margin: 0 0 20px;
  padding-left: 28px;
}

.faq-card-content :deep(li) {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/page/faq.vue